import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { Payment } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";
import { fulfilmentApi } from "../fulfilment/fulfilment.api";

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/admin/payment",
    credentials: "include",
  }),
  endpoints: (build) => ({
    createPayment: build.mutation<any, Partial<any>>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            fulfilmentApi.util.invalidateTags([
              "FulfilmentPayments",
              "FulfilmentSummary",
            ]),
          );
        } catch {
          /* create failed — list stays as-is */
        }
      },
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
      },
    }),
    getPayments: build.query<{ payments: Payment[]; total: number }, Partial<any>>({
      query: (params) => ({
        url: "/all",
        method: "GET",
        params,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
      },
    }),
    getAdminPayments: build.query<{ payments: Payment[]; total: number }, Partial<any>>({
      query: () => ({
        url: "/adminPayments",
        method: "GET",
      }),
    }),
    getPaymentDetails: build.query<Payment, string>({
      query: (id) => ({
        url: "/details/" + id,
        method: "GET",
      }),
    }),
    getReport: build.query<any, Partial<any>>({
      query: (params) => ({
        url: "/report",
        method: "GET",
        params,
      }),

      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
      },
    }),
  }),
});

export const {
  useCreatePaymentMutation,
  useGetPaymentsQuery,
  useLazyGetReportQuery,
  useLazyGetPaymentDetailsQuery,
  useGetAdminPaymentsQuery,
} = paymentApi;
